import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=589cd800&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"
import style0 from "./Heading.vue?vue&type=style&index=0&id=589cd800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589cd800",
  null
  
)

export default component.exports